import { MenuItem, Typography, Select, useTheme } from "@mui/material";
import { styled } from "@mui/material";

export const StyledSelect = styled(Select)<{ noPointer?: boolean }>(({ theme, noPointer }) => ({
  pointerEvents: noPointer ? "none" : "auto",
  borderRadius: theme.spacing(1.5),
  backgroundColor: theme.palette.surface.container,
  overflow: "hidden",

  ".MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(1.5),
    backgroundColor: theme.palette.surface.silver,
    pointerEvents: noPointer ? "none" : "auto",
    width: "100%",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${theme.palette.border.dark}`,
    borderRadius: theme.spacing(1.5),
  },

  "& .MuiSelect-icon": {
    color: theme.palette.text.secondary,
    fontSize: "24px",
  },

  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${theme.palette.border.dark}`,
    },
  },
}));

export const BaseSelect = ({
  value,
  defaultValue,
  onChange,
  options,
}: {
  value: any;
  defaultValue: any;
  onChange: (value: any) => void;
  options: { label: string; value: string }[];
}) => {
  const theme = useTheme();
  return (
    <StyledSelect
      sx={{ display: "flex", alignItems: "center", gap: theme.spacing(1), minWidth: "fit-content" }}
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
      MenuProps={{
        slotProps: {
          paper: {
            sx: {
              borderRadius: theme.spacing(1.5),
              backgroundColor: theme.palette.surface.silver,
              padding: theme.spacing(0.5, 2),
            },
          },
        },
      }}
      IconComponent={undefined}>
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{ display: "flex", alignItems: "center", gap: theme.spacing(1) }}>
          <Typography
            variant="body-default"
            color="text.secondary"
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              textAlign: "center",
              gap: theme.spacing(1),
              minHeight: "26px",
            }}>
            {option.label}
          </Typography>
        </MenuItem>
      ))}
    </StyledSelect>
  );
};
